import { IMenuItemDb } from "@dining/api-client";
import { SearchBox, Stack } from "@fluentui/react";
import * as React from "react";
import { useSelector } from "react-redux";
import { stationItemBankSelector, stationSelector } from "../../selectors/diningSelector";
import styles from "../../styles/content.module.css";
import AddItemPanel from "../AddItem/AddItemPanel";
import { ItemList } from "./ItemList";

export const FiltrableMenuItemBank = () => {
  const selectedStation = useSelector(stationSelector);
  const stationName = selectedStation?.name || "Select a station on the left to begin.";

  //Save items from API call, set component state
  const itemBank = useSelector(stationItemBankSelector);
  const [menuItems, setMenuItems] = React.useState<IMenuItemDb[]>(itemBank);
  //Runs on the first render
  //And any time itemBank value changes when a different station is selected
  React.useEffect(() => {
    setMenuItems(itemBank);
  }, [itemBank]);

  // Filtering the items by name according to user input in search bar
  const _onChangeText = (event: React.ChangeEvent<HTMLInputElement>, text: string): void => {
    text
      ? setMenuItems(itemBank.filter((i) => i.name.toLowerCase().includes(text.trim().toLowerCase())))
      : setMenuItems(itemBank);
  };
  // for accessiblity, we need to tell user the search result in aria label.
  const searchResults = (menuItems: IMenuItemDb[] | null): string => {
    if (menuItems && menuItems.length > 0) {
      if (menuItems.length === 1) {
        return "one search result is found.";
      } else {
        return `${menuItems.length} search results are found.`;
      }
    }
    return "no search result is found";
  };

  return (
    <Stack className={styles.itemGridContainer} grow={false} verticalFill={false} tokens={{ childrenGap: 10 }}>
      <Stack horizontal={true} horizontalAlign="space-between" verticalAlign="center" wrap={true}>
        <h2 className={styles.itemGridStationName}>{stationName}</h2>
        <AddItemPanel />
      </Stack>
      {selectedStation && (
        <>
          <SearchBox
            ariaLabel={`Search box for menu items, ${searchResults(menuItems)}`}
            placeholder="Search"
            onChange={_onChangeText}
          />
          <ItemList itemBank={menuItems} />
        </>
      )}
    </Stack>
  );
};
